import { userHasAnyPermission } from '@/helpers/userPermissions'

// Rotas cobertas pelas permissões já existentes no catálogo do EasyGestor.
// O backend continua sendo a autoridade final; este mapa evita exibir telas
// que certamente serão recusadas pela API.
export const routePermissionRules = {
  home: ['user.view'],
  userGetAll: ['user.view'],
  register: ['user.insert'],
  userProfiles: ['role.view'],
  empresas: ['empresa.view'],
  pessoas: ['pessoa.view'],
  produtos: ['produto.view'],
  item: ['produto.view'],
  tabela: ['produto.view'],
  'parametros-grupos': ['grupo.view'],
  'parametros-cidades': ['cidade.view'],
  'parametros-series': ['empresa.view'],
  'parametros-unidademed': ['unidade.view'],
  'parametros-tipospagamento': ['empresa.view'],
  'parametros-tiposmovimento': ['empresa.view'],
}

export function getRoutePermissionRule(route) {
  if (!route || !route.name) return null
  if (routePermissionRules[route.name]) return routePermissionRules[route.name]

  const path = String(route.path || '').replace(/^\/+/, '')
  const pathModules = [
    ['cadastros/empresas', 'empresa'],
    ['cadastros/localestoque', 'localestoque'],
    ['cadastros/pessoas', 'pessoa'],
    ['cadastros/produtos', 'produto'],
    ['cadastros/item', 'produto'],
    ['cadastros/tabela', 'produto'],
    ['cadastros/plano', 'plano_conta'],
    ['cadastro/venda', 'venda'],
    ['cadastro/contaCorrente', 'corrente'],
    ['financeiro/agenciaBanc', 'agencia'],
    ['financeiro/bancos', 'banco'],
    ['financeiro/contasReceber', 'receber'],
    ['financeiro/contasPagar', 'pagas'],
    ['financeiro/controle_de_caixa', 'movimento-caixa'],
    ['financeiro/controle_cheque', 'chequeEmitido'],
    ['financeiro/ordem_servico', 'pedido'],
    ['parametros/grupos', 'grupo'],
    ['parametros/cidades', 'cidade'],
    ['parametros/series', 'serie'],
    ['parametros/unidademed', 'unidade'],
    ['parametros/tipos', 'configuracao'],
    ['produto', 'produto'],
    ['pessoa', 'pessoa'],
    ['empresa', 'empresa'],
    ['user', 'user'],
    ['usuarios', 'user'],
    ['nfe', 'nfe'],
    ['pedido', 'pedido'],
    ['venda', 'venda'],
  ]
  const match = pathModules.find(([prefix]) => path === prefix || path.startsWith(prefix + '/'))
  const permissionModule = match ? match[1] : null
  return permissionModule ? [permissionModule + '.view'] : null
}

export function userCanAccessRoute(user, route) {
  const permissions = getRoutePermissionRule(route)
  if (!permissions) return true
  if (user && Array.isArray(user.roles) && user.roles.some(role => role && role.name === 'super')) {
    return true
  }
  return userHasAnyPermission(user, permissions)
}
